import { Key } from 'react';
import { useNavigate } from 'react-router-dom';
import { SortDescriptor, Selection } from '@ds';
import { DataTable } from '@ui';
import { TABLE_COLUMNS } from '@lp/features/MultiSuggest/utils';
import { SuggestionSummaryType } from '@/api/apis/multi-suggest';
import { MultiCaseSuggestTableCell } from './MultiCaseSuggestTableCell';

type Props = {
  data: SuggestionSummaryType[];
  page: number;
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;
  sortBy: SortDescriptor | undefined;
  isLoading?: boolean;
  isFetching?: boolean;
  setPage: (page: number) => void;
  setItemsPerPage: (itemsPerPage: number) => void;
  setSortBy: (sortBy: SortDescriptor | undefined) => void;
};

export const MultiCaseSuggestTable = ({
  data,
  page,
  itemsPerPage,
  totalItems,
  totalPages,
  sortBy,
  isLoading = false,
  isFetching = false,
  setPage,
  setItemsPerPage,
  setSortBy,
}: Props) => {
  const navigate = useNavigate();

  const renderCell = (item: SuggestionSummaryType, columnKey: Key) => (
    <MultiCaseSuggestTableCell item={item} columnKey={columnKey} />
  );

  const openMultiSuggestResults = (ids: Selection) => {
    const list = Array.from(ids);

    navigate(`/multi-case-suggest/${list[0]}`);
  };

  return (
    <DataTable
      idKey="id"
      label="Multi-Case Suggestions"
      columns={TABLE_COLUMNS}
      renderCell={renderCell}
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      totalItems={totalItems}
      totalPages={totalPages}
      hideHeader={!data.length}
      page={page}
      itemsPerPage={itemsPerPage}
      sortBy={sortBy}
      onPageChange={setPage}
      onItemsPerPageChange={setItemsPerPage}
      onSortByChange={setSortBy}
      selectionMode="single"
      onSelectionChange={openMultiSuggestResults}
      emptyContent={
        <div className="flex flex-col gap-0.5 items-center">
          <span className="font-normal text-l-r text-base-20">No Multi‑Case Suggestions have been found.</span>
          <span className="font-normal text-l-r text-base-20">
            You can start a new suggestion by clicking <span className="font-bold">Add New</span> to select an origin
            and target cases and explore resource exchange options.
          </span>
        </div>
      }
    />
  );
};
